<template>
  <v-container v-if="gavancesadmin !== null" grid-list-xl>
    <v-toolbar flat color="primary">
      <div class="text-white">
        {{ gavancesadmin.codigo }} - {{ gavancesadmin.nombre }}
      </div>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-divider></v-divider>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card :elevation="2" :loading="loading">
          <v-card-title>Edición de Avances</v-card-title>
          <v-card-text>
            <v-flex xs12 row>
              <v-flex xs12 sm12>
                <v-card :elevation="2" :loading="loading" :disabled="loading">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchAvCuantitativos"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text active-class="deep-purple accent-4 white--text">
                    <v-data-table
                      :headers="headeravancecuantitativo"
                      :items="avancescuantitativos"
                      class="elevation-1"
                      :items-per-page="5"
                      :no-data-text="gnodata"
                      :search="searchAvCuantitativos"
                    >
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="editAvanceCuantitativo(item)"
                              >edit</v-icon
                            >
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="eliminarCuantitativo(item)"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              v-if="puedeverauditoria()"
                              small
                              class="mr-2"
                              @click="VerAuditoriaRegistroCuantitativo(item)"
                              >fa-glasses</v-icon
                            >
                          </template>
                          <span>Ver auditoría</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:top>
                        <v-toolbar color="white">
                          <v-toolbar-title
                            ><p class="font-weight-light">
                              Avances cuantitativos.
                            </p></v-toolbar-title
                          >
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="dialogCuantitativo"
                            max-width="500px"
                          >
                            <template v-slot:activator="{ on: dialog }">
                              <v-btn-toggle>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on: tooltip }">
                                    <v-btn
                                      mx-1
                                      color="primary"
                                      v-on="{ ...tooltip, ...dialog }"
                                      @click="nuevocuantitativo"
                                    >
                                      <v-icon color="white">add</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Agregar</span>
                                </v-tooltip>
                                <v-tooltip top>
                                  <template v-slot:activator="{ on }">
                                    <v-btn
                                      color="primary"
                                      v-on="on"
                                      @click="nuevoextemporaneo('cualitativo')"
                                    >
                                      <v-icon color="white"
                                        >fas fa-history</v-icon
                                      >
                                    </v-btn>
                                  </template>
                                  <span>avances extemporáneos</span>
                                </v-tooltip>
                              </v-btn-toggle>
                            </template>

                            <v-card>
                              <v-card-text v-if="EditCuantitativo != null">
                                <v-layout row wrap>
                                  <v-flex xs12 sm12>
                                    <v-menu
                                      ref="menu"
                                      v-model="menuPicker"
                                      :close-on-content-click="false"
                                      :return-value.sync="
                                        EditCuantitativo.diaCorte
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                      :disabled="!UserAdmin"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-combobox
                                          v-model="EditCuantitativo.diaCorte"
                                          chips
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          label="Fecha de corte: *"
                                        ></v-combobox>
                                      </template>
                                      <v-date-picker
                                        v-model="EditCuantitativo.diaCorte"
                                        no-title
                                        scrollable
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="menuPicker = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="
                                            $refs.menu.save(
                                              EditCuantitativo.diaCorte
                                            )
                                          "
                                        >
                                          OK
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                  </v-flex>

                                  <v-flex xs12 sm6 class="col-padd">
                                    <v-text-field
                                      v-model="EditCuantitativo.rangoperiodo"
                                      label="Periodo"
                                    >
                                    </v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm6 class="col-padd">
                                    <v-select
                                      :items="metas"
                                      v-model="Metaseleccionada"
                                      item-text="periodo"
                                      item-value="idmeta"
                                      label="Año meta: *"
                                      :disabled="!UserAdmin"
                                    ></v-select>
                                  </v-flex>

                                  <v-flex xs12 sm6 class="col-padd">
                                    <v-select
                                      :items="
                                        gestados.filter(function (params) {
                                          return (
                                            params.idestado != 5 &&
                                            params.idestado != 6
                                          );
                                        })
                                      "
                                      v-model="EditCuantitativo.idestado"
                                      item-text="nombre"
                                      item-value="idestado"
                                      label="Estado: *"
                                      @change="CambiarEstado"
                                      :disabled="
                                        validarcuantitativo(EditCuantitativo)
                                      "
                                    ></v-select>
                                  </v-flex>

                                  <v-flex
                                    xs12
                                    sm6
                                    v-if="
                                      EditCuantitativo.idmetaNavigation != null
                                    "
                                    class="col-padd"
                                  >
                                    <v-text-field
                                      v-model="
                                        EditCuantitativo.idmetaNavigation.valor
                                      "
                                      disabled
                                      label="Valor de Meta"
                                    >
                                    </v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  color="blue darken-1"
                                  @click="dialogCuantitativo = false"
                                  >Cancelar</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  @click="dialogSoportes = true"
                                  >Guardar</v-btn
                                >
                                <!-- saveCuantitativoTemp -->
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.soportes`]="{ item }">
                        <div v-if="item.soportes == true">Si</div>
                        <div v-else>No</div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12>
                <v-card :elevation="2" :loading="loading" :disabled="loading">
                  <v-card-title>
                    <v-spacer></v-spacer>
                    <v-text-field
                      v-model="searchAvCualitativos"
                      append-icon="search"
                      label="Buscar"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                  <v-card-text active-class="deep-purple accent-4 white--text">
                    <v-data-table
                      :headers="headeravancecualitativo"
                      :items="avancescualitativos"
                      class="elevation-1"
                      :items-per-page="5"
                      :no-data-text="gnodata"
                      :search="searchAvCualitativos"
                    >
                      <template v-slot:[`item.action`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="editAvanceCualitativo(item)"
                              >edit</v-icon
                            >
                          </template>
                          <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="eliminarCualitativo(item)"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              v-if="puedeverauditoria()"
                              small
                              class="mr-2"
                              @click="VerAuditoriaRegistroCualitativo(item)"
                              >fa-glasses</v-icon
                            >
                          </template>
                          <span>Ver auditoría</span>
                        </v-tooltip>
                      </template>
                      <template v-slot:top>
                        <v-toolbar color="white">
                          <v-toolbar-title
                            ><p class="font-weight-light">
                              Avances cualitativos.
                            </p></v-toolbar-title
                          >
                          <v-divider class="mx-4" inset vertical></v-divider>
                          <v-spacer></v-spacer>
                          <v-dialog
                            v-model="dialogCualitativo"
                            max-width="500px"
                          >
                            <template v-slot:activator="{ on: dialog }">
                              <v-tooltip top>
                                <template v-slot:activator="{ on: tooltip }">
                                  <v-btn
                                    color="primary"
                                    v-on="{ ...tooltip, ...dialog }"
                                    @click="nuevocualitativo"
                                  >
                                    <v-icon>add</v-icon>
                                  </v-btn>
                                </template>
                                <span>Agregar</span>
                              </v-tooltip>
                            </template>

                            <v-card>
                              <v-card-text v-if="EditCualitativo != null">
                                <v-layout row wrap>
                                  <v-flex xs12 sm12>
                                    <v-menu
                                      ref="menu"
                                      v-model="menuPicker1"
                                      :close-on-content-click="false"
                                      :return-value.sync="
                                        EditCualitativo.diaCorte
                                      "
                                      transition="scale-transition"
                                      offset-y
                                      min-width="auto"
                                      :disabled="!UserAdmin"
                                    >
                                      <template
                                        v-slot:activator="{ on, attrs }"
                                      >
                                        <v-combobox
                                          v-model="EditCualitativo.diaCorte"
                                          chips
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          label="Fecha de corte: *"
                                        ></v-combobox>
                                      </template>
                                      <v-date-picker
                                        v-model="EditCualitativo.diaCorte"
                                        no-title
                                        scrollable
                                      >
                                        <v-spacer></v-spacer>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="menuPicker1 = false"
                                        >
                                          Cancel
                                        </v-btn>
                                        <v-btn
                                          text
                                          color="primary"
                                          @click="
                                            $refs.menu.save(
                                              EditCualitativo.diaCorte
                                            )
                                          "
                                        >
                                          OK
                                        </v-btn>
                                      </v-date-picker>
                                    </v-menu>
                                  </v-flex>

                                  <v-flex xs12 sm6 class="col-padd">
                                    <v-text-field
                                      v-model="EditCualitativo.rangoperiodo"
                                      label="Periodo"
                                    >
                                    </v-text-field>
                                  </v-flex>

                                  <v-flex xs12 sm6 class="col-padd">
                                    <v-select
                                      :items="
                                        gestados.filter(function (params) {
                                          return (
                                            params.idestado != 5 &&
                                            params.idestado != 6
                                          );
                                        })
                                      "
                                      v-model="EditCualitativo.idestado"
                                      item-text="nombre"
                                      item-value="idestado"
                                      label="Estado: *"
                                      :disabled="
                                        validarcualitativo(EditCualitativo)
                                      "
                                      @change="CambiarEstado"
                                    ></v-select>
                                  </v-flex>
                                </v-layout>
                              </v-card-text>
                              <v-card-actions>
                                <v-btn
                                  color="blue darken-1"
                                  @click="dialogCualitativo = false"
                                  >Cancelar</v-btn
                                >
                                <v-btn
                                  color="blue darken-1"
                                  @click="dialogSoportes = true"
                                  >Guardar</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </v-toolbar>
                      </template>
                      <template v-slot:[`item.soportes`]="{ item }">
                        <div v-if="item.soportes == true">Si</div>
                        <div v-else>No</div>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-dialog v-model="dialogExtemporaneo" max-width="500px">
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12 sm6>
                        <v-select
                          :items="Listaaños"
                          v-model="EditExtemporaneo.diaInicio"
                          prepend-icon="mdi-calendar"
                          label="Año inicio: *"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                          :items="Listaaños"
                          v-model="EditExtemporaneo.diaFin"
                          prepend-icon="mdi-calendar"
                          label="Año fin: *"
                        ></v-select>
                      </v-flex>

                      <v-flex xs12 sm12>
                        <p>
                          este proceso genera avances cualitativos y
                          cuantitativos para el indicador
                          {{ gavancesadmin.codigo }}; El proceso de creación de
                          extemporáneos puede ser demorado.
                        </p>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="blue darken-1"
                      @click="dialogExtemporaneo = false"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" @click="crearExtemporaneo"
                      >Generar extemporaneo</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogSoportes" width="800" persistent>
                <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title>
                    Soportes de la versión
                  </v-card-title>

                  <v-card-text>
                    <v-row>
                      <v-col xs12 sm6 md6>
                        <v-text-field
                          data-vv-name="numeroradicado"
                          v-model="versionadodatosadicionales.numeroradicado"
                          label="Número radicado"
                          :clearable="this.puedeeditar()"
                          v-validate="'required|numeric'"
                          :counter="50"
                          data-vv-scope="versionadodatosadicionales"
                          :error-messages="
                            errors.collect(
                              'numeroradicado',
                              'versionadodatosadicionales'
                            )
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col xs12 sm6 m6>
                        <v-menu
                          ref="menuSoportes"
                          v-model="menuSoportes"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                          readonly
                        >
                          <template v-slot:activator="{ on }">
                            <div>
                              <v-text-field
                                v-model="fechaformateada"
                                label="Fecha radicado:"
                                prepend-icon="event"
                                v-on="on"
                                v-validate="'required'"
                                data-vv-name="fecharadicado"
                                data-vv-scope="versionadodatosadicionales"
                                :error-messages="
                                  errors.collect(
                                    'fecharadicado',
                                    'versionadodatosadicionales'
                                  )
                                "
                                @blur="
                                  fecharadicado = parseDate(fechaformateada)
                                "
                              ></v-text-field>
                            </div>
                          </template>
                          <div>
                            <v-date-picker
                              v-model="fecharadicado"
                              no-title
                              scrollable
                              locale="es"
                            >
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menuSoportes = false"
                                >Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                readonly
                                @click="
                                  $refs.menuSoportes.save(fechaformateada)
                                "
                                >OK</v-btn
                              >
                            </v-date-picker>
                          </div>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs12 sm12 m12>
                        <v-textarea
                          v-model="versionadodatosadicionales.comentario"
                          label="Comentario:"
                          v-validate="'required'"
                          data-vv-name="comentario"
                          data-vv-scope="versionadodatosadicionales"
                          :error-messages="
                            errors.collect(
                              'comentario',
                              'versionadodatosadicionales'
                            )
                          "
                          :clearable="this.puedeeditar()"
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col xs12 sm12 m12>
                        <v-data-table
                          :headers="headerFieldsSoportes"
                          :items="soportes"
                          class="elevation-2"
                          :no-data-text="gnodata"
                          dense
                          :items-per-page="10"
                        >
                          <template v-slot:item.action="{ item }">
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  @click="deletesoporteversion(item)"
                                  >delete</v-icon
                                >
                              </template>
                              <span>Eliminar</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-icon
                                  v-on="on"
                                  small
                                  class="mr-2"
                                  @click="descargarsoporte(item)"
                                  >mdi-file</v-icon
                                >
                              </template>
                              <span>Descargar</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                    <v-flex row>
                      <v-flex xs12 md10 sm10>
                        <template>
                          <v-file-input
                            accept=".pdf, .xlsx, .xls"
                            v-model="fileversionadosoporte"
                            show-size
                            multiple
                            label="cargar archivo"
                            @change="onVersionadoSoporteChange"
                          ></v-file-input>
                        </template>
                      </v-flex>
                      <v-flex xs12 md2 sm2>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              outlined
                              v-on="on"
                              class="ma-2"
                              @click="Addversionadosoporte"
                              tile
                              color="success"
                            >
                              <v-icon left>add</v-icon>Agregar
                            </v-btn>
                          </template>
                          <span>Agregar archivo</span>
                        </v-tooltip>
                      </v-flex>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="text-white" color="blue darken-1" @click="dialogSoportes = false">Cancelar</v-btn>
                    <v-btn
                      class="text-white"
                      color="blue darken-1"
                      @click="preventguardardatosadicionales"
                      >Guardar</v-btn
                    >
                  </v-card-actions>
                </v-card>
                <v-snackbar
                  v-model="snack"
                  :timeout="timeoutsnak"
                  :color="MesaggeInfo.color"
                >
                  {{ this.MesaggeInfo.codigoRespuesta }}
                  {{ this.MesaggeInfo.mensajeRespuesta }}
                  <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
                  <v-btn text v-show="snackalert" @click="cancelsave"
                    >Cancelar</v-btn
                  >
                </v-snackbar>
              </v-dialog>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack" :timeout="5000" :color="MesaggeInfo.color">
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="snack = false">Cerrar</v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import _ from "lodash";
import { ErrorBag } from 'vee-validate';
import { LegendSettings } from "@amcharts/amcharts4/charts";
import soportecambio from "../../components/content/soportecambio";
export default {
  name: "admin_avances",
  data() {
    return {
      //Soportes
      fecharadicado: new Date().toISOString().substr(0, 10),
      fecharadicadoseleccionada: null,
      fechaformateada: '',
      tiposarchivo: null,
      soportes: [],
      fileversionadosoporte: null,
      dialogSoportes: false,
      snackalert: false,
      versionadodatosadicionales: {numeroradicado:'', fecharadicado:'',comentario:'', fecharadicadoformateada:''},
      headerFieldsSoportes: [
        {
          value: "nombrearchivo",
          text: "Nombre",
          sortable: true,
          width: "150px",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10%" }
      ],
      menuSoportes: false,
      idtabla: [10,11],
      timeoutsnak: 4000,
      buttontext: "cerrar",
      //Fin Soportes
      
      avancescualitativos: [],
      avancescuantitativos: [],
      metas: [],
      Indexcuantitativo: -1,
      Indexcualitativo: -1,
      EditCuantitativo: {},
      EditCualitativo: {},
      EditExtemporaneo: {},
      dialogCuantitativo: false,
      dialogCualitativo: false,
      dialogExtemporaneo: false,
      estadoExtemporaneo: "",
      periodicidadExt: 0,
      menuPicker: false,
      menuPicker1: false,
      menuPicker2: false,
      Metaseleccionada: "",
      MetaExtemporaneo: "",
      UserAdmin: false,
      CurrentUser: [],
      searchAvCualitativos: "",
      searchAvCuantitativos: "",

      //campos de la tabla avance cuantitativo
      headeravancecuantitativo: [
        { text: "Fecha Corte", value: "diaCorte", align: "center" },
        { text: "Periodo a Reportar", value: "rangoperiodo", align: "center" },
        { text: "Meta", value: "idmetaNavigation.periodo", align: "center" },
        { text: "Adjuntos", value: "soportes", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Acciones", value: "action", sortable: false },
      ],

      headeravancecualitativo: [
        { text: "Fecha Corte", value: "diaCorte", align: "center" },
        { text: "Periodo a Reportar", value: "rangoperiodo", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Adjuntos", value: "soportes", align: "center" },
        { text: "Acciones", value: "action", sortable: false },
      ],

      Listaaños: [
        "2017",
        "2018",
        "2019",
        "2020",
        "2021",
        "2022",
        "2023",
        "2024",
        "2025",
        "2026",
        "2027",
        "2028",
        "2029",
        "2030",
        "2031",
        "2032",
        "2033",
        "2034",
        "2035",
        "2036",
        "2037",
        "2038",
        "2039",
        "2040",
      ],
      snack: false,
      snackColor: "",
      snackText: "",
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],

      returpath: "",
      loading: false,
      recargar: false,
    };
  },
  components: {
    soportecambio,
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  methods: {
    ...mapActions("usuario/", ["get_usuarios"]),
    ...mapActions([
      "get_avancesAdmin",
      "get_estados",
      "Getperiodicidad",
      "GenerarExtemporaneos",
      "ActualizarCualitativo",
      "delete_cualitativo",
      "ActualizarCuantitativo",
      "delete_cuantitativo",
      "get_porusuario",
      "get_configuraciones",
      "downloadsoporteversion",
      "putversionadodatosadicionalestablas"
    ]),
    //Soportes
    deletesoporteversion(item) {
      const index = this.soportes.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoporteVersion.push(item);
        this.soportes.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      if (item.archivocompleto == null) {
        this.downloadsoporteversion({
          params: {
            idtabla: this.idtabla[0],
            idindicador: this.idregistro,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = item.archivocompleto;
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    onVersionadoSoporteChange() {
      this.imageUrlversionadosoporte = [];
      let error = false;
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          if (error === false) {
            let file = this.fileversionadosoporte[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportes.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idversionado === this.selectedversionado)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlversionadosoporte.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en la versión";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlversionadosoporte = [];
          this.fileversionadosoporte = [];
        }
      }
    },
    Addversionadosoporte() {
      if (this.fileversionadosoporte !== null) {
        for (let i = 0; i < this.fileversionadosoporte.length; i++) {
          let file = this.fileversionadosoporte[i];

          this.soporteversion = Object.assign({}, this.soportes);
          this.soporteversion.nombrearchivo = file.name,
          this.soporteversion.tipoarchivo = file.type,
          this.soporteversion.finalizado = false,
          this.soporteversion.archivocompleto = this.imageUrlversionadosoporte[i],
          this.soporteversion.idsoporte = 0
          
          this.soportes.push(this.soporteversion);
        }
        this.imageUrlversionadosoporte = [];
        this.fileversionadosoporte = [];
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    preventguardardatosadicionales()  {
      this.$validator.validateAll("versionadodatosadicionales").then(async (result) => {
        if (!result || this.soportes.length == 0) {
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          
          let bag = new ErrorBag();
          bag = this.errors;
          if(bag.first('fileversionadosoporte', 'versionadodatosadicionales') !== undefined)
            bag.removeById(bag.first('fileversionadosoporte', 'versionadodatosadicionales').id);
          //bag.remove(bag.first('fileversionadosoporte').id);
         
          if(this.soportes.length == 0 && bag.first('fileversionadosoporte', 'versionadodatosadicionales') == undefined)
          {
            bag.add({
                scope: 'versionadodatosadicionales',
                field: 'fileversionadosoporte',
                msg: 'Al menos un archivo de soporte es requerido'
            });
          }
          
          this.$validator.errors.items.forEach((element) => {
            if(element.scope == "versionadodatosadicionales")
              Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          
          return;
        } else {
          
          this.Editarentidad = false;
          if(this.dialogCuantitativo)
          {
            await this.saveCuantitativoTemp();
            this.Savesoportedatosadicionales(10);
          }
          else if(this.dialogCualitativo)
          {
              await this.saveCualitativoTemp();
              this.Savesoportedatosadicionales(11);
          }
        }
      });
      
    },
    async Savesoportedatosadicionales(idtabla){

      await this.putversionadodatosadicionalestablas({
          data: {
            idtabla: [idtabla], 
            versionadoDatosAdicionales: {
                                        idversionadodatosadicionales: this.versionadodatosadicionales.idversionadodatosadicionales,
                                        comentario: this.versionadodatosadicionales.comentario,
                                        numeroradicado: this.versionadodatosadicionales.numeroradicado,
                                        fecharadicado: this.versionadodatosadicionales.fecharadicado
                                        }, 
            soportesVersionado: this.soportes,
            soportesEliminar : this.deletesoporteVersion
            }
      });

      this.versionadodatosadicionales = {numeroradicado:'', fecharadicado:'',comentario:'', fecharadicadoformateada:''};
      this.fechaformateada= '';
      this.soportes = [];
      this.deletesoporteVersion = [];
      this.dialogSoportes = false;
      this.loading = false;
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formato(value, sinhora) {
      if (value && sinhora == false) {
        return moment(String(value)).format("DD/MM/YYYY HH:mm");
      }
      else
      {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    puedeeditar() {
      let opciones = this.gopciones.filter((p) => p.codigo === "O004-1-8")[0];
      return opciones != undefined;
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.buttontext == "cerrar";
        this.snack = false;
        this.timeoutsnak = 4000;
        let ruta = this.returpath;
        if (ruta == "") {
          if (localStorage.pathfrom != "/") ruta = localStorage.pathfrom;
          ruta = "/tareas";
        }
        this.$router.push(ruta);
      }
    },
    //Fin Soportes
    decriptarID() {
      let user = this.getusuario();
      let auten = user.token.replace("Bearer ", "");
      this.$aes.setKey(auten);
      let temporal = this.$route.params.idindicador.replace(/AbcYq/g, "/");
      temporal = temporal.replace(/qYcbA/g, "+");
      temporal = this.$aes.decrypt(temporal);
      temporal = temporal.substring(4);
      temporal = temporal.substring(0, temporal.length - 4);
      temporal = this.$aes.decrypt(temporal);
      return temporal;
    },
    getusuario() {
      if (localStorage.usuario !== undefined) {
        return JSON.parse(unescape(localStorage.usuario));
      } else {
        return null;
      }
    },
    editAvanceCuantitativo(item) {
      let user = this.getusuario();
      this.Indexcuantitativo = this.avancescuantitativos.indexOf(item);
      this.EditCuantitativo = Object.assign({}, item);
      this.Metaseleccionada = this.EditCuantitativo.idmeta;
      this.dialogCuantitativo = this.validartareasadmin(
        user.usuarioRol[0].idrol,
        item.idestado
      );
    },
    eliminarCuantitativo(item) {
      let user = this.getusuario();
      if (this.validartareasadmin(user.usuarioRol[0].idrol, item.idestado)) {
        if (
          confirm(
            "¿Esta seguro de eliminar el avance cuantitativo con periodo " +
              item.rangoperiodo +
              " ? "
          )
        ) {
          this.loading = true;
          this.recargar = true;
          this.delete_cuantitativo({
            params: {
              idavancecuantitativo: item.idavancecuantitativo,
            },
          });
        }
      }
    },
    async saveCuantitativoTemp() {
      this.dialogSoportes = false;
      if (this.validacomponentes(this.EditCuantitativo)) {
        this.EditCuantitativo.fechacorte = this.formatofechaVb(
          this.EditCuantitativo.diaCorte
        );
        this.EditCuantitativo.idindicador = this.gavancesadmin.idindicador;
        if (this.Indexcuantitativo == -1) {
          this.EditCuantitativo.idindicador = this.gavancesadmin.idindicador;
        }
        this.loading = true;
        this.recargar = true;
        await this.ActualizarCuantitativo({
          data: this.EditCuantitativo,
        });
        this.closeCuantitativo();
      }
    },
    validartareasadmin(idusuario, idestado) {
      if (idusuario != 1 && idestado != 7) {
        this.snack = true;
        this.buttontext = "aceptar";
        this.MesaggeInfo.mensajeRespuesta =
          "Los registros en gestion solo pueden ser modificador por el Administrador del sistema";
        this.MesaggeInfo.color = "infovue";
        return false;
      }
      return true;
    },
    Hoy() {
      var today = new Date();
      var day = today.getDate() + "";
      var month = today.getMonth() + 1 + "";
      var year = today.getFullYear() + "";
      let DateToday = year + "-" + month + "-" + day;
      return DateToday;
    },
    FechaFormat(fecha) {
      var today = new Date(fecha);
      var day = today.getDate() + "";
      var month = today.getMonth() + 1 + "";
      var year = today.getFullYear() + "";
      let DateToday = year + "-" + month + "-" + day;
      return DateToday;
    },
    formatofechaVb(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
      }
    },
    nuevocuantitativo() {
      let DateToday = this.Hoy();
      this.Metaseleccionada = 0;
      this.EditCuantitativo = {
        idavancecuantitativo: 0,
        diaCorte: DateToday,
        idestado: 7,
        idmeta: 0,
        valor: 0,
        rangoperiodo: "",
      };
    },
    closeCuantitativo() {
      this.Indexcuantitativo = -1;
      this.EditCuantitativo = {};
      this.dialogCuantitativo = false;
      this.Indexcualitativo = -1;
      this.EditCualitativo = {};
      this.dialogCualitativo = false;
    },
    CambiarEstado(val) {
      let nuevoestado = this.gestados.filter(function (params) {
        return params.idestado == val;
      });
      if (nuevoestado.length > 0) {
        if (this.EditCuantitativo.idestado != undefined)
          this.EditCuantitativo.estado = nuevoestado[0].nombre;
        if (this.EditCualitativo.idestado != undefined)
          this.EditCualitativo.estado = nuevoestado[0].nombre;
      }
    },
    editAvanceCualitativo(item) {
      let user = this.getusuario();
      this.Indexcualitativo = this.avancescualitativos.indexOf(item);
      this.EditCualitativo = Object.assign({}, item);
      this.dialogCualitativo = this.validartareasadmin(
        user.usuarioRol[0].idrol,
        item.idestado
      );
    },
    eliminarCualitativo(item) {
      let user = this.getusuario();
      if (this.validartareasadmin(user.usuarioRol[0].idrol, item.idestado)) {
        if (
          confirm(
            "¿Esta seguro de eliminar el avance cualitativo con periodo " +
              item.rangoperiodo +
              " ? "
          )
        ) {
          this.loading = true;
          this.recargar = true;
          this.delete_cualitativo({
            params: {
              idavancecualitativo: item.idavancecualitativo,
            },
          });
        }
      }
    },
    async saveCualitativoTemp() {
      if (this.validacomponentes(this.EditCualitativo)) {
        this.EditCualitativo.fechacorte = this.formatofechaVb(
          this.EditCualitativo.diaCorte
        );
        if (this.Indexcualitativo == -1) {
          this.EditCualitativo.idindicador = this.gavancesadmin.idindicador;
        }
        this.recargar = true;
        this.loading = true;
        await this.ActualizarCualitativo({
          data: this.EditCualitativo,
        });
        this.loading = true;
        this.closeCuantitativo();
      }
    },
    nuevocualitativo() {
      let DateToday = this.Hoy();

      this.EditCualitativo = {
        idavancecualitativo: 0,
        diaCorte: DateToday,
        idestado: 7,
        descripcion: "",
        rangoperiodo: "",
      };
    },
    validarcualitativo(item) {
      if (item.idavancecualitativo == 0 || this.UserAdmin == false) return true;
      else return false;
    },
    validarcuantitativo(item) {
      if (item.idavancecuantitativo == 0 || this.UserAdmin == false)
        return true;
      else return false;
    },
    nuevoextemporaneo(item) {
      this.estadoExtemporaneo = item;
      this.dialogExtemporaneo = true;
      let avancesordenados = _.orderBy(
        this.avancescuantitativos,
        ["fechacorte"],
        ["desc"]
      );
      let YearBegin = 0;
      let YearEnd = 0;
      if (avancesordenados[0].fechacorte != undefined) {
        var lastdate = new Date(avancesordenados[0].fechacorte);
        YearBegin = lastdate.getFullYear() + "";
        YearBegin = (parseInt(YearBegin) + 1).toString();
      } else {
        var today = new Date();
        YearBegin = today.getFullYear() + "";
      }
      YearEnd = (parseInt(YearBegin) + 1).toString();
      this.EditExtemporaneo = {
        diaInicio: YearBegin,
        diaFin: YearEnd,
      };
    },
    crearExtemporaneo() {
      //if (this.EditExtemporaneo.diaInicio >= this.EditExtemporaneo.diaFin)

      this.gavancesadmin.fechaInicio = this.EditExtemporaneo.diaInicio;
      this.gavancesadmin.fechaFin = this.EditExtemporaneo.diaFin;
      if (this.gavancesadmin.fechaFin < this.gavancesadmin.fechaInicio) {
        this.snack = true;
        this.buttontext = "aceptar";
        this.MesaggeInfo.mensajeRespuesta =
          "la fecha fin no puede ser menor a la fecha inicio";
        this.MesaggeInfo.color = "warnvue";
      } else {
        this.recargar = true;
        this.loading = true;
        this.dialogExtemporaneo = false;
        this.GenerarExtemporaneos({
          data: this.gavancesadmin,
        });
      }
    },
    validacomponentes(item) {
      if (item.idmeta == 0) {
        this.snack = true;
        this.buttontext = "aceptar";
        this.MesaggeInfo.mensajeRespuesta = "Debe seleccionar el año meta";
        this.MesaggeInfo.color = "warnvue";
        return false;
      }

      if (item.rangoperiodo == "") {
        this.snack = true;
        this.buttontext = "aceptar";
        this.MesaggeInfo.mensajeRespuesta = "Debe digitar el Rango Periodo";
        this.MesaggeInfo.color = "warnvue";
        return false;
      }

      if (item.idestado == 0) {
        this.snack = true;
        this.buttontext = "aceptar";
        this.MesaggeInfo.mensajeRespuesta = "Debe seleccionar un estado";
        this.MesaggeInfo.color = "warnvue";
        return false;
      }
      return true;
    },
    puedeverauditoria() {
      let opciones = this.gopciones.filter((p) => p.codigo === "O004-1-7")[0];
      return opciones != undefined;
    },
    VerAuditoriaRegistroCuantitativo(item) {
      let link = "/detalleauditoriaav/10/" + item.idavancecuantitativo;
      this.$router.push(link);
    },
    VerAuditoriaRegistroCualitativo(item) {
      let link = "/detalleauditoriaav/11/" + item.idavancecualitativo;
      this.$router.push(link);
    },
  },
  created() {
    this.returpath = localStorage.pathfrom;
    this.get_usuarios();
    this.get_estados();
    this.Getperiodicidad();
    this.get_configuraciones();
    let temporal = this.decriptarID();
    //let temporal = 468
    this.get_avancesAdmin({
      params: {
        idindicador: temporal,
      },
    });
  },
  computed: {
    ...mapGetters(["gavancesadmin", "gestados", "gperiodicidad", "gopciones", "gversionados", "gconfiguraciones"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
  },
  watch: {
    gavancesadmin: function () {
      this.avancescualitativos = this.gavancesadmin.avanceCualitativos;
      this.avancescuantitativos = this.gavancesadmin.avanceCuantitativos;
      this.metas = this.gavancesadmin.metaNavigation;
      this.CurrentUser = this.getusuario();
    },
    Metaseleccionada: function () {
      if (this.EditCuantitativo.idmeta != this.Metaseleccionada) {
        let Metatemp = this.Metaseleccionada;
        this.EditCuantitativo.idmetaNavigation = this.metas.filter(function (
          params
        ) {
          return params.idmeta == Metatemp;
        })[0];
        if (this.EditCuantitativo.idmetaNavigation.idmeta != undefined) {
          this.EditCuantitativo.idmeta =
            this.EditCuantitativo.idmetaNavigation.idmeta;
          this.EditCuantitativo.valor =
            this.EditCuantitativo.idmetaNavigation.valor;
        }
      }
    },
    ginformation() {
      if (this.loading) {
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        this.buttontext = "aceptar";
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
      }
      if (this.recargar) {
        if (this.ginformation.idGenerado == 1) {
          console.log(this.ginformation);
          // this.snack = true;

          // this.MesaggeInfo.mensajeRespuesta = "Se ingresaron registros extemporaneos";
          // this.MesaggeInfo.color = "infovue";
          this.get_avancesAdmin({
            params: {
              idindicador: this.gavancesadmin.idindicador,
            },
          });
          // this.$refs.sc.mostrarPopupCambio();
        } else {
          this.MesaggeInfo = this.ginformation;
          this.snack = true;
          console.log(this.MesaggeInfo.mensajeRespuesta);
        }
        this.recargar = false;
      }
    },
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(
        (X) => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
    },
    CurrentUser: function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.CurrentUser.usuarioRol != undefined) {
          this.CurrentUser.usuarioRol.forEach((dato) => {
            if (dato.nombreRol.toUpperCase() == "ADMINISTRADOR")
              this.UserAdmin = true;
          });
        }
      }
    },
    //Soportes
    gversionados: function () {
      this.cargando = false;
      this.versiones = this.gversionados;
      
    },
    versionadodatosadicionales(){
      if(this.versionadodatosadicionales.fecharadicadoformateada!= '')
      {
        console.log("this.versionadodatosadicionales.fecharadicadoformateada", this.versionadodatosadicionales.fecharadicadoformateada);
        this.fechaformateada = this.formato(this.versionadodatosadicionales.fecharadicadoformateada, true);
      }
    },
    fecharadicado () {
      if(this.fecharadicado != '')
      {
        console.log("this.fecharadicado", this.fecharadicado);
         this.fechaformateada = this.formato(this.fecharadicado, true);
         this.versionadodatosadicionales.fecharadicado = this.fecharadicado;
      }
    },
  },
};
</script>